import React from 'react';
import PolymarketDistributionCard from './PolymarketDistributionCard';

function EndOfYearRateCard({ data }) {
  const subtitle = (
    <>
      Polymarket-implied · top buckets by YES probability
      {data?.total_volume ? ` · $${Math.round(data.total_volume).toLocaleString()} volume` : ''}
    </>
  );

  return (
    <PolymarketDistributionCard
      data={data}
      title={`What will the Fed rate be at the end of ${data?.year ?? ''}?`}
      subtitle={subtitle}
      unavailableTitle="Fed rate at year-end"
    />
  );
}

export default EndOfYearRateCard;
